<template>
  <b-row>
    <b-col xl="12" md="12" sm="12">
      <transition name="slide">
      <b-card :header="caption" >
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="trainingsArray" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
           <template slot="team" slot-scope="data">
            <strong>{{Object.values(data.item.val().team)[0].name}}</strong>
          </template>
          <template slot="title" slot-scope="data">
            <strong>{{data.item.val().title}}</strong>
          </template>
          <template slot="description" slot-scope="data">
            <strong>{{showDescription(data.item.val().description)}}</strong>
          </template>
          <template slot="date" slot-scope="data">
            <strong>{{data.item.val().date}}</strong>
          </template>
          <template slot="hour" slot-scope="data">
            <strong>{{data.item.val().hour}}</strong>
          </template>
          <template slot="created" slot-scope="data">
            {{new Date(data.item.val().created).toGMTString()}}
          </template>
          <template slot="modified" slot-scope="data">
            {{new Date(data.item.val().modified).toGMTString()}}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="trainingsArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          <b-row class="align-items-center">
            <b-col xl= "4" sm="6" md="4" class="mb-3 mb-xl-0" >
              <b-button v-on:click="addTrainingButton" block variant="primary">Add Training</b-button>
            </b-col>
        </b-row>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
export default {
  name: 'Trainings',
  firebase: {
    trainings: db.ref('teamTrainings')
  },
  props: {
    caption: {
      type: String,
      default: 'Trainings'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      //items: teamsData.filter((team) => team.id < 10),
      // items: [],
      // items: this.$firebaseRefs.teams,
      // items: this.getTeams(),
      fields: [
        {key: 'team'},
        {key: 'title'},
        {key: 'description'},
        {key: 'date'},
        {key: 'hour'},
        {key: 'created'},
        {key: 'modified'}
      ],
      trainingsArray: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  created(){
      this.trainingsArray = []
      db.ref('teamTrainings').on('value', (snapshot) =>{
        console.log(snapshot.val())
        snapshot.forEach(childSnapshot => {
          console.log(childSnapshot.val())
          childSnapshot.forEach(trainingSnapshot => {
            console.log(trainingSnapshot.val())
            this.trainingsArray.push(trainingSnapshot)
          })
          //this.trainingsArray.push(childSnapshot.val())
          //return childSnapshot.val()
        })
      })
  },
  methods: {
    trainingLink (id) {
      return `trainings/${id}`
    },
    rowClicked (training) {

      console.log(training)
      const teamKey = Object.keys(training.val().team)[0]
      console.log(teamKey)

      
      const trainingLink = `trainings/` + training.key + '&&' + teamKey
      this.$router.push({path: trainingLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addTrainingButton () {
      this.$router.push({path: 'trainings/addtraining'})
    },
    showDescription(description){
      if(description.length > 20){
        return description.substring(0,20) + '...'
      }else{
        return description
      }
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
